export interface ScheduleDateFields {
  startDate?: string | null;
  endDate?: string | null;
}

export interface ScheduleStartDateField {
  startDate?: string | null;
}

export function hasScheduleStartDate<T extends ScheduleStartDateField>(
  dates: T | null | undefined,
): dates is T & { startDate: string } {
  return typeof dates?.startDate === "string" && dates.startDate !== "";
}

export function hasScheduleDates<T extends ScheduleDateFields>(
  dates: T | null | undefined,
): dates is T & { startDate: string; endDate: string } {
  return (
    hasScheduleStartDate(dates) &&
    typeof dates.endDate === "string" &&
    dates.endDate !== ""
  );
}

/**
 * The 1-based week a cohort is in: the last section whose start date has
 * passed (week 1 before the first one starts). Sections without a start date
 * are not calendar weeks and are left out.
 */
export function currentCohortWeek(
  sections: readonly ScheduleStartDateField[],
  today: Date,
): number {
  const started = sections.filter(
    (section) =>
      hasScheduleStartDate(section) && new Date(section.startDate) <= today,
  ).length;
  return Math.max(1, started);
}
